import { Component, Input, Pipe, PipeTransform, EventEmitter, Output, OnDestroy, ViewChild, Inject, ChangeDetectorRef, ElementRef, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {ApiService} from '../../../shared/api.service';
import { finalize } from 'rxjs/operators';
import { SlideshowService } from '../../slideshow.service';
import { Utils } from '../.././../utils';

@Component({
    selector: 'embed-content-component',
    templateUrl: 'embed.component.html'
})

export class EmbedContentComponent {
    private _canEdit = false;
    private _embed = "";
    private _oldEmbed = "";
    private _html;
    private _provider;
    private _error;

    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('embed')
    set embed(embed) {
        this._embed = embed;
    }
    get embed() {
        return this._embed;
    }
    set html(html) {
        this._html = html;
    }
    get html() {
        return this._html;
    }

    @Output() embedChange = new EventEmitter();

    constructor(
        public slideshow: SlideshowService,
        public utils: Utils,
        private api: ApiService,
        private containerRef: ElementRef
    ) {}
    ngOnInit() {
        this.slideEmbedChange();
    }
    slideEmbedChange() {
        if(this._oldEmbed !== this.embed) {
            this.getOembed(this.embed.replace('http://', 'https://'));
            this._oldEmbed = this.embed;
        }

        this.embedChange.emit(this.embed);
    }
    getOembed(url) {
        this.api.doAction('post', 'oembed', {
            url: url
        }).pipe(
            finalize(() => {
                let container = this.containerRef.nativeElement.querySelectorAll('.embeds')[0];
                if(container) {
                    let containerInner = container.querySelectorAll('.embed')[0];
                    if(containerInner) {
                        containerInner.innerHTML = '';
                        if(this.html) {
                            containerInner.appendChild(this.html);

                            if(this._provider === 'Facebook') {
                                if(window['FB']) {
                                    window['FB'].XFBML.parse();
                                }
                            } else if(this._provider === 'Twitter') {
                                if(window['twttr']) {
                                    window['twttr'].widgets.load();
                                }
                            } else if(this._provider === 'Instagram') {
                                if(window['instgrm']) {
                                    window['instgrm'].Embeds.process();
                                }
                            }
                        } else {
                            let err = 'Cannot embed the given URL';
                            if(this._error) {
                                err = 'Failed to embed the given URL, please try again';
                            }
                            containerInner.innerHTML = `<div class="embed-placeholder faded"><div class="embed-error"><mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">error_outline</mat-icon><span>${err}</span></div></div>`
                        }
                    }
                }
            })
        ).subscribe(
            data => {
                console.log(data);
                this._error = false;
                if(data.data) {
                    this.html = document.createRange().createContextualFragment(data.data.html);
                    this._provider = data.data.provider_name;
                } else {
                    this.html = false;
                }
            },
            err => {
                console.log(err);
                this.html = false;
                this._error = true;
                throw err;
            }
        );
    }
}